export const Paths = {
    default: '/api/customer-portal/schedules',
    v1: {
        confirm: '/customer-portal/v1/schedule/status/confirm/batch',
        cancel: '/customer-portal/v1/schedule/:id/status/cancel',
        resendBilling: '/customer-portal/v1/schedule/:id_schedule/resend-billing',
    },
};
